module.exports = __webpack_public_path__ + "img/course-2.50360816.jpeg";